    document.addEventListener('DOMContentLoaded', () => {
      const bundleItems = document.querySelectorAll('.bundle-static--product-item');
      const addAllBtn = document.getElementById('add-all-to-cart');
      const totalPriceEl = document.getElementById('bundle-total-price');

      if (!addAllBtn || !bundleItems.length) return;

      const mainId = Number(addAllBtn.dataset.mainId);
      const mainPrice = Number(addAllBtn.dataset.mainPrice);

      function updateTotal() {
        let total = mainPrice;
        bundleItems.forEach(item => {
          const price = Number(item.dataset.variantPrice);
          const qty = parseInt(item.querySelector('.quantity-display').textContent, 10);
          total += price * qty;
        });
        totalPriceEl.innerText = (total / 100).toFixed(2).replace('.', ',') + '€';
      }

      bundleItems.forEach(item => {
        const incBtn = item.querySelector('.quantity-increment');
        const decBtn = item.querySelector('.quantity-decrement');
        const display = item.querySelector('.quantity-display');

        incBtn.addEventListener('click', () => {
          let qty = parseInt(display.textContent, 10);
          qty++;
          display.textContent = qty;
          updateTotal();
        });

        decBtn.addEventListener('click', () => {
          let qty = parseInt(display.textContent, 10);
          if (qty > 0) {
            qty--;
            display.textContent = qty;
            updateTotal();
          }
        });
      });

      addAllBtn.addEventListener('click', (e) => {
        e.preventDefault(); // 🔐 bloquer tout comportement Shopify par défaut

        const items = [];
        items.push({ id: Number(mainId), quantity: 1 });

        bundleItems.forEach(item => {
          const variantId = Number(item.dataset.variantId);
          const qty = parseInt(item.querySelector('.quantity-display').textContent, 10);
          if (qty > 0) {
            items.push({ id: variantId, quantity: qty });
          }
        });

        if (items.length === 0) {
          showToast("Aucun produit sélectionné.");
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) throw new Error('Erreur Shopify');
          return response.text();
        })
        .then(() => {
          showToast("Produits ajoutés au panier !");
          window.location.href = '/cart?reload=' + Date.now();
        })
        .catch(error => {
          console.error('Erreur panier :', error);
          showToast("Erreur lors de l'ajout au panier.");
        });
      });

      function showToast(message) {
        const toast = document.createElement('div');
        toast.textContent = message;
        toast.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #7A656F;
          color: #fff;
          padding: 1.5rem 2rem;
          border-radius: 1.5rem;
          z-index: 9999;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
          opacity: 0;
          transition: opacity 0.3s ease;
        `;
        document.body.appendChild(toast);
        requestAnimationFrame(() => {
          toast.style.opacity = '1';
        });
        setTimeout(() => {
          toast.style.opacity = '0';
          setTimeout(() => toast.remove(), 300);
        }, 3000);
      }
      updateTotal();
    });